var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Defaults, Watch, PropertyConverters, ViewChild, Debounce, Utils } from '@pacem/pacem-core';
import { Components as ScaffoldingComponents } from '@pacem/pacem-scaffolding';
//namespace Pacem.Components.Cms {
export class PacemElementPickerElementBase extends ScaffoldingComponents.Scaffolding.PacemBaseElement {
}
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemElementPickerElementBase.prototype, "selector", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Eval })
], PacemElementPickerElementBase.prototype, "filter", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Eval })
], PacemElementPickerElementBase.prototype, "labeler", void 0);
let PacemElementPickerElement = class PacemElementPickerElement extends PacemElementPickerElementBase {
    get inputFields() {
        return [this._select];
    }
    toggleReadonlyView(readonly) {
        this._select.readonly = readonly;
    }
    onChange(_) {
        return Utils.fromResult(this.value = this._select.value);
    }
    acceptValue(val) {
        this._select.value = val;
    }
    getViewValue(value) {
        return this._select.viewValue;
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Element.convert(attr);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._databind();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'selector':
                case 'filter':
                case 'labeler':
                    this._databind();
                    break;
            }
        }
    }
    _databind() {
        const project = this.labeler || (e => {
            let label = e.constructor.name;
            if (e.id) {
                label += '#' + e.id;
            }
            return label;
        });
        const retval = [];
        document.querySelectorAll(this.selector || '[pacem]').forEach((e, i, arr) => {
            if ((Utils.isNull(this.filter) || this.filter(e) === true)
                // let' say 'id' is a must-have...
                && !Utils.isNullOrEmpty(e.id)) {
                retval.push({ element: e, label: project(e) });
            }
        });
        this._select.valueProperty = 'element';
        this._select.textProperty = 'label';
        this._select.datasource = retval;
    }
};
__decorate([
    ViewChild(P + '-select')
], PacemElementPickerElement.prototype, "_select", void 0);
__decorate([
    Debounce(50)
], PacemElementPickerElement.prototype, "_databind", null);
PacemElementPickerElement = __decorate([
    CustomElement({
        tagName: P + '-element-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-select></${P}-select>`
    })
], PacemElementPickerElement);
export { PacemElementPickerElement };
